<mat-form-field class="full-width-field">
  <mat-label>Status</mat-label>

  <mat-select
    multiple
    [ngModel]="selected"
    (ngModelChange)="onSelectionModelChange($event)"
    (openedChange)="onOpenedChange($event)"
    panelClass="status-group-filter-panel">

    <!-- Compact chip summary on the closed trigger, with +N overflow. -->
    <mat-select-trigger>
      <ng-container *ngIf="triggerLabels().length as total">
        <span class="status-chip">{{ triggerLabels()[0] }}</span>
        <span class="status-chip" *ngIf="total > 1">{{ triggerLabels()[1] }}</span>
        <span class="status-chip status-chip-more" *ngIf="total > 2">+{{ total - 2 }}</span>
      </ng-container>
    </mat-select-trigger>

    <!-- Search box, pinned above the option groups. -->
    <div class="status-search" (click)="$event.stopPropagation()">
      <mat-icon class="status-search-icon">search</mat-icon>
      <input
        type="text"
        placeholder="Search statuses"
        [(ngModel)]="searchText"
        [ngModelOptions]="{ standalone: true }"
        (keydown)="onSearchKeydown($event)"
        autocomplete="off">
    </div>

    <ng-container *ngFor="let group of groups">
      <mat-optgroup *ngIf="groupHasVisibleOptions(group)" [label]="group.label">
        <mat-option
          *ngFor="let option of visibleOptions(group)"
          [value]="option.token">
          <span class="status-option-name">{{ option.name }}</span>
          <span class="status-option-count" *ngIf="optionCount(group, option) !== null">
            {{ optionCount(group, option) | number }}
          </span>
        </mat-option>
      </mat-optgroup>
    </ng-container>

    <div class="status-clear" *ngIf="selected.length">
      <button type="button" mat-button color="primary" (click)="clearSelection(); $event.stopPropagation()">
        Clear selection
      </button>
    </div>
  </mat-select>
</mat-form-field>
